<template>
  <div class="p-4 bg-white">
    <div class="text-center font-bold">EDIT</div>
    <div>
      <v-text-field label="Department" v-model="department"></v-text-field>
    </div>
    <div class="text-center">
      <v-btn @click="$emit('cancelEdit')" small>Cancel</v-btn>
      <v-btn @click="update" small>Update</v-btn>
    </div>
    <v-snackbar top v-model="snackbar">
      {{ snackbarText }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import EventBus from "@/EventBus";
import Axios from "axios";

export default {
  data() {
    return {
      department: null,
      snackbar:false,
      snackbarText:null
    };
  },
  props: ["item"],
  watch: {
    item: {
      handler(e) {
        if (e) {
          this.department = e.department;
        }
      },
      immediate: true,
    },
  },
  methods: {
    update() {
      let data = {
        department_id: this.item.department_id,
        department: this.department,
      };
      Axios.post("/departments/edit", data).then((res) => {
        if (res.data.status) {
          EventBus.$emit("refreshDepartment");
        } else {
          this.snackbar = true;
          this.snackbarText = res.data.message;
        }
      });
    },
  },
};
</script>
